import { giphyPink, giphyIndigo, giphyLightBlue, giphyPurple, giphyBlue, giphyRed } from '@giphy/js-brand'

export const colors = [giphyIndigo, giphyPink, giphyPurple, giphyLightBlue, giphyBlue, giphyRed]
const ITEMS_PER_LINE = 3

export const hexToRGBA = (hex: string, alpha: number | string): string => {
    const r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16)

    if (alpha) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')'
    } else {
        return 'rgb(' + r + ', ' + g + ', ' + b + ')'
    }
}

export const getOpacity = (index: number): string | number => {
    const module = index % ITEMS_PER_LINE

    switch (module) {
        case 0:
            return 1
        case 1:
            return 0.66
        case 2:
            return 0.33
        default:
            return `${100 / module}%`
    }
}
